module.exports = __webpack_public_path__ + "img/LaBase-Mojito-Cup-Cake-600px.e04bb47f.jpg";